import { render, staticRenderFns } from "./AdminFormazione.vue?vue&type=template&id=3ad35cf6&scoped=true&"
import script from "./AdminFormazione.vue?vue&type=script&lang=js&"
export * from "./AdminFormazione.vue?vue&type=script&lang=js&"
import style0 from "./AdminFormazione.vue?vue&type=style&index=0&id=3ad35cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad35cf6",
  null
  
)

export default component.exports